import React, { useState, useEffect } from "react";
import Header from "../layout/Header";
import { Footer } from "../layout/Footer";

const TermsAndCondition = () => {
  const styles = {
    list: {
      listStyleType: "lower-alpha",
      paddingLeft: "54px",
      textAlign: "justify",
    },

    text: {
      textAlign: "justify",
      paddingLeft: "20px",
    },
    ulist: {
      paddingLeft: "44px",
    },
  };
  return (
    <div className="site-main">
      <Header />
      <div className="ttm-page-title-row">
        <div className="container-xl">
          <div className="row">
            <div className="col-md-12">
              <div className="title-box text-center">
                <div className="page-title-heading">
                  <h1 className="title">Terms & Conditions</h1>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="margin-top-css">
        <div className="container-xl">
          <div>
            <h3>1. Introduction</h3>
            <p style={styles.text}>
              By accessing or using our website and services, you agree to
              comply with these Terms and Conditions ("T&C"). You are
              responsible for compliance with all applicable local laws in your
              jurisdiction. If you do not agree, you must refrain from using our
              services.
            </p>

            <p style={styles.text}>
              These T&C govern the use of services provided by{" "}
              <strong>Cognitude</strong> ("Company," "we," "us," "our") to you
              ("you," "your"). By engaging in our vulnerability scanning
              services, you acknowledge and agree to be bound by these T&C.
            </p>

            <h3>2. Definitions</h3>
            <p style={styles.text}>
              For the purposes of these T&C, the following definitions apply:
            </p>
            <ol type="a" style={styles.list}>
              <li>
                “Data” means any representation of information, facts, concepts,
                opinions, or instructions suitable for communication,
                interpretation, or processing by humans or automated means.
              </li>
              <li>
                “Law” includes any ordinance, order, by-law, rule, regulation,
                notification, custom, or usage in a relevant jurisdiction,
                passed or made by a competent authority, governing the use of
                website vulnerability scans in that jurisdiction.
              </li>
              <li>
                “Personal Data” means any data about an individual identifiable
                by or in relation to such data.
              </li>
              <li>
                “Platform” refers to the medium or system through which we
                deliver or facilitate services.
              </li>
              <li>
                “Relevant Jurisdiction” refers to the legal territory whose laws
                govern the use, operation, and compliance of the vulnerability
                scanner, based on the geographical location where services are
                deployed, accessed, operated, or utilized. This includes
                national, regional, or local laws and authorities responsible
                for their governance.
              </li>
              <li>
                “Services” refers to the provision of website vulnerability
                scanning by us.
              </li>
              <li>
                “Service Provider” refers to the company providing website
                vulnerability scanning services.
              </li>
              <li>
                “User” refers to any individual or legal entity engaging with
                Cognitude for its services.
              </li>
              <li>
                “User Data” refers to personal data and data submitted by the
                user.
              </li>
              <li>
                “Vulnerability Scanning” refers to the process of inspecting and
                reporting potential vulnerabilities and security loopholes on a
                website.
              </li>
            </ol>
            <br />
            <h3>3. Use of Services</h3>
            <p style={styles.text}>
              You agree to use our services only for lawful purposes and in
              compliance with all applicable laws. By engaging our services, you
              confirm:
            </p>
            <ul style={styles.ulist}>
              <li>
                <strong>i.</strong> You have the legal authority to engage
                Cognitude for website vulnerability scanning services.
              </li>
              <li>
                <strong>ii.</strong> You will provide accurate data and
                necessary permissions required to test the website.
              </li>
            </ul>
            <br />
            <h3>4. Rules of Conduct</h3>
            <p style={styles.text}>
              You must not perform any of the following prohibited activities:
            </p>

            <ul style={styles.ulist}>
              <li>
                <strong>i.</strong> Using the Platform or Services for unlawful
                or unauthorized purposes.
              </li>
              <li>
                <strong>ii.</strong> Soliciting others to perform or participate
                in unlawful or unauthorized acts.
              </li>
              <li>
                <strong>iii.</strong> Violating any international, federal,
                provincial, or state laws, or applicable legal compliance.
              </li>
              <li>
                <strong>iv.</strong> Collecting or tracking others' data,
                including personal data.
              </li>
              <li>
                <strong>v.</strong> Making, transmitting, or storing copyrighted
                materials without permission, or infringing on intellectual
                property rights.
              </li>
              <li>
                <strong>vi.</strong> Submitting false or misleading data,
                including personal data.
              </li>
              <li>
                <strong>vii.</strong> Using deep-links, page-scrapes, robots,
                spiders, or similar tools to increase traffic, access data, or
                circumvent the Platform or Services.
              </li>
              <li>
                <strong>viii.</strong> Decompiling, reverse engineering, or
                disassembling the Platform or Services' contents.
              </li>
              <li>
                <strong>ix.</strong> Modifying the Platform or Services'
                functionality, coding, or appearance.
              </li>
              <li>
                <strong>x.</strong> Performing overloading, stress tests, or
                similar evaluations without permission.
              </li>
              <li>
                <strong>xi.</strong> Modifying, copying, distributing,
                transmitting, displaying, reproducing, publishing, selling,
                licensing, transferring, or creating derivative works from
                obtained data.
              </li>
              <li>
                <strong>xii.</strong> Using obtained data to tamper, steal,
                impersonate, or cheat.
              </li>
              <li>
                <strong>xiii.</strong> Removing copyright, trademark, or
                proprietary notices.
              </li>
              <li>
                <strong>xiv.</strong> Uploading or transmitting viruses, worms,
                or malicious code.
              </li>
              <li>
                <strong>xv.</strong> Attempting spamming, phishing, pretexting,
                scraping, or data harvesting.
              </li>
              <li>
                <strong>xvi.</strong> Interfering with, circumventing, or
                disabling security features.
              </li>
              <li>
                <strong>xvii.</strong> Accessing or using the Platform or
                Services in a way that damages, disables, or impairs
                functionality.
              </li>
              <li>
                <strong>xviii.</strong> Interfering with or denying access to
                others.
              </li>
              <li>
                <strong>xix.</strong> Violating user privacy or disclosing
                confidential data.
              </li>
              <li>
                <strong>xx.</strong> Using fake identities or accounts.
              </li>
              <li>
                <strong>xxi.</strong> Sharing login credentials or activation
                codes with unauthorized users.
              </li>
              <li>
                <strong>xxii.</strong> Assigning, subletting, transferring, or
                delegating rights without written consent.
              </li>
              <li>
                <strong>xxiii.</strong> Using for obscene or immoral purposes.
              </li>
              <li>
                <strong>xxiv.</strong> Threatening national unity, integrity,
                security, or sovereignty.
              </li>
              <li>
                <strong>xxv.</strong> Using for purposes not permitted by law or
                accepted practices.
              </li>
              <li>
                <strong>xxvi.</strong> Violating these T&C.
              </li>
            </ul>
            <br />
            <h3>5. Breach and Violation</h3>
            <ul style={styles.ulist}>
              <li>
                <strong>i.</strong> Violations of these T&C or any Company
                policy may result in account suspension or termination, and
                legal remedies.
              </li>
              <li>
                <strong>ii.</strong> In the event of a breach, you acknowledge
                that the Company will be irreparably harmed and may seek
                injunctive relief.
              </li>
            </ul>
            <br />
            <h3>6. Indemnification</h3>
            <ul style={styles.ulist}>
              <li>
                <strong>i.</strong> You agree to indemnify and hold harmless the
                Company and its affiliates from all claims, losses, damages,
                suits, judgments, litigation costs, and attorneys' fees arising
                from your use of the Platform or Services, breach of these T&C,
                or violation of law or third-party rights.
              </li>
              <li>
                <strong>ii.</strong> The Company is not liable for any losses or
                damages arising from your use of the Platform or Services,
                whether based on warranty, contract, tort, or otherwise.
              </li>
              <li>
                <strong>iii.</strong> We are not liable for any loss or damage
                resulting from use or inability to use the Platform, or for
                delays or failures beyond our control.
              </li>
            </ul>
            <br />
            <h3>7. Severability</h3>
            <p style={styles.text}>
              If any provision of these T&C is found unenforceable, it will be
              enforced to the maximum extent permissible, and the remaining
              provisions will continue in effect.
            </p>
            <br />
            <h3>8. Waiver and Entire Agreement</h3>
            <p style={styles.text}>
              Failure to enforce any right or provision does not constitute a
              waiver. These T&C and any posted policies constitute the entire
              agreement, superseding prior agreements. Ambiguities will not be
              construed against the drafting party.
            </p>
            <br />
            <h3>9. Non-Compete Clause</h3>
            <p style={styles.text}>
              During and for one month after termination, you will not compete
              with the vulnerability scanner or its technologies without written
              consent, globally. Breach will result in legal action.
            </p>
            <br />
            <h3>10. Governing Law and Dispute Resolution</h3>
            <ul style={styles.ulist}>
              <li>
                <strong>i.</strong> Disputes will be governed by Indian law and
                subject to arbitration in Chennai under the Arbitration and
                Conciliation Act, 1996. The Chennai courts have exclusive
                jurisdiction.
              </li>
              <li>
                <strong>ii.</strong> Arbitration will be conducted by a sole
                arbitrator mutually appointed, in English, with the award being
                final and binding.
              </li>
            </ul>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default TermsAndCondition;
